import { useNavigate } from 'react-router-dom'
import { useAuth } from '@craft/shared'
import { logout } from '../lib/firebase'
import { questions } from '../data/questions'
import Logo from '../components/Logo'

export default function DashboardPage() {
  const navigate = useNavigate()
  const { user, userData, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0a0e1a' }}>
        <p className="text-white/50">読み込み中…</p>
      </div>
    )
  }

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0a0e1a' }}>
        <div className="text-center">
          <p className="text-white/50 mb-4">ログインが必要です</p>
          <button onClick={() => navigate('/')} className="px-6 py-3 rounded-lg font-bold text-white"
            style={{ background: 'linear-gradient(135deg, #34D399, #14B8A6)' }}>
            ホームへ
          </button>
        </div>
      </div>
    )
  }

  const completed = userData?.completedChem || []
  const scores = userData?.scoresChem || {}
  const total = questions.length
  const doneCount = completed.length
  const progress = Math.round((doneCount / total) * 100)

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0a0e1a 0%, #111827 100%)', fontFamily: "'Noto Sans JP', sans-serif" }}>
      <header className="flex items-center justify-between px-4 md:px-8 py-4 border-b border-white/10">
        <Logo size="sm" />
        <div className="flex items-center gap-3">
          <span className="text-xs text-white/50">{user.email}</span>
          <button onClick={() => logout()} className="text-sm text-white/50 hover:text-white">ログアウト</button>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
        <h1 className="text-2xl md:text-3xl font-black text-white mb-6">ダッシュボード</h1>

        {/* 進捗 */}
        <div className="p-6 rounded-2xl mb-8"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)' }}>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-bold text-white/70">学習の進捗</span>
            <span className="text-sm font-bold" style={{ color: '#34D399' }}>{doneCount} / {total} 問</span>
          </div>
          <div className="h-3 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
            <div className="h-full rounded-full transition-all"
              style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #34D399, #14B8A6)' }} />
          </div>
        </div>

        {/* 問題別 */}
        <h2 className="text-lg font-bold text-white mb-3">問題別の記録</h2>
        <div className="space-y-2 mb-8">
          {questions.map((q) => {
            const isDone = completed.includes(q.id)
            const best = scores[q.id]
            return (
              <button key={q.id} onClick={() => navigate(`/learn/${q.id}`)}
                className="w-full flex items-center justify-between p-3.5 rounded-xl transition-all hover:scale-[1.01]"
                style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="flex items-center gap-3 min-w-0">
                  <span className="text-xs font-bold text-white/40 shrink-0">Q{q.id}</span>
                  <span className="text-sm font-semibold text-white truncate">{q.title}</span>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  {best != null && <span className="text-xs text-white/50">{best}点</span>}
                  {isDone
                    ? <span className="text-[10px] px-2 py-0.5 rounded-full font-bold" style={{ background: '#22C55E22', color: '#4ADE80' }}>✓ 完了</span>
                    : <span className="text-[10px] px-2 py-0.5 rounded-full font-bold text-white/40" style={{ background: 'rgba(255,255,255,0.06)' }}>未挑戦</span>}
                </div>
              </button>
            )
          })}
        </div>

        <button onClick={() => navigate('/questions')}
          className="w-full py-3.5 rounded-xl font-bold text-white"
          style={{ background: 'linear-gradient(135deg, #34D399, #14B8A6)' }}>
          問題一覧へ
        </button>
      </div>
    </div>
  )
}
